import { getTripInvitationLinkDescription } from '../../apis/metaData';
import { metaTagString } from '../../utilities/meta_tags_util';

const getSecretId = () => process.env.SECRET_ID_FOR_META_TAGS;

async function loadData(urlPath, language, query, params) {
  let metaData = '';
  const { tripId, invitationId } = params;

  try {
    const response = await getTripInvitationLinkDescription(
      tripId,
      invitationId,
      getSecretId(),
    );
    const { data } = response;

    if (data.status === '200') {
      const { name, image } = data.results;
      switch (language) {
        case 'zh-cn': {
          metaData += metaTagString({
            urlPath,
            title: `${name} 旅游群组邀请`,
            description: '透过 Funliday 寻找下一趟旅程，轻松安排旅游行程。',
            images: [image],
            language,
            noindex: true,
          });
          break;
        }
        case 'zh-tw': {
          metaData += metaTagString({
            urlPath,
            title: `${name} 旅遊群組邀請`,
            description: '透過 Funliday 尋找下一趟旅程，輕鬆安排旅遊行程。',
            images: [image],
            language,
            noindex: true,
          });
          break;
        }
        case 'zh': {
          metaData += metaTagString({
            urlPath,
            title: `${name} 旅遊群組邀請`,
            description: '透過 Funliday 尋找下一趟旅程，輕鬆安排旅遊行程。',
            images: [image],
            language,
            noindex: true,
          });
          break;
        }
        case 'ja': {
          metaData += metaTagString({
            urlPath,
            title: `${name} 旅行グループへの招待`,
            description:
              'Funliday は、次の旅行先を見つけるお手伝いをしてくれます！次の旅行に活用して楽に計画しよう！',
            images: [image],
            language,
            noindex: true,
          });
          break;
        }
        case 'ko': {
          metaData += metaTagString({
            urlPath,
            title: `${name} 여행 그룹 초대`,
            description:
              'Funliday 는 다음 목적지를 찾고 여행을 쉽게 구성 할 수 있도록 도와줍니다.',
            images: [image],
            language,
            noindex: true,
          });
          break;
        }
        default: {
          metaData += metaTagString({
            urlPath,
            title: `${name} Travel group invitation`,
            description:
              'Funliday helps you find the next destination and organize your trip easily.',
            images: [image],
            language,
            noindex: true,
          });
          break;
        }
      }
    }
    if (data.status === '204' || data.status === '400') {
      return {
        notFound: true,
      };
    }
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }

  return {
    metaData,
  };
}

export default loadData;
